/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import axios from "axios";
import { Badge, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../../../config.json";
import "../../../../../i18n";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import videImg from "../../../../../assets/images/vide-item.png";
import "../Subcategory/Subgategories.css";

const Categories = ({
  category,
  fetchCategories,
  selected = false,
  onToggleSelect,
}) => {
  const { t } = useTranslation();
  const { _id, photo, categoryDetails = [], isArchived } = category;
  const [displayOrientation, setDisplayOrientation] = useState(
    category.displayOrientation === "horizontal" ? "horizontal" : "vertical"
  );
  const [orientationSaving, setOrientationSaving] = useState(false);

  useEffect(() => {
    setDisplayOrientation(
      category.displayOrientation === "horizontal" ? "horizontal" : "vertical"
    );
  }, [category.displayOrientation, _id]);

  const setDisplayOrientationTo = async (next) => {
    if (next === displayOrientation || orientationSaving) return;
    setOrientationSaving(true);
    try {
      await axios.put(
        `${config.dev}/v2/categories/edit/${_id}`,
        { displayOrientation: next },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
          },
        }
      );
      setDisplayOrientation(next);
      fetchCategories();
      swal(t("successTitle"), t("orientationUpdated"), "success");
    } catch (error) {
      swal("ERROR", error?.response?.data?.message || String(error), "error");
    } finally {
      setOrientationSaving(false);
    }
  };

  const hideCategory = async () => {
    try {
      await axios.put(
        `${config.dev}/v2/categories/hide/${_id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
          },
        }
      );
      swal("SUCCESS", "Category is in hide mode", "success");
      fetchCategories();
    } catch (error) {
      swal("ERROR", "" + error, "error");
    }
  };

  if (isArchived) return null; // <-- on ne rend rien si archivé

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className={`card kitchen-card${selected ? " is-selected" : ""}`}>
        <div className="card-body">
          <div className="new-arrival-product">
            <div className="kitchen-card__top">
              <input
                type="checkbox"
                className="kitchen-card__check"
                checked={selected}
                onChange={() => onToggleSelect?.(_id)}
                aria-label={t("selectAll")}
              />
              <div className="basic-dropdown kitchen-card__menu">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    className="btn-sm"
                    id="category-actions"
                  >
                    <i className="fas fa-ellipsis-v" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      as={Link}
                      to={`/category-details/${_id}`}
                      className="kitchen-action-view"
                    >
                      <i className="fas fa-eye me-2" />
                      {t("details")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      to={`/edit-category/${_id}`}
                      className="text-warning"
                    >
                      <i className="fas fa-pen me-2 text-warning" />
                      {t("edit")}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={hideCategory} className="text-danger-dark">
                      <i className="fas fa-archive me-2 text-danger-dark" />
                      {t("archive")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            <div className="new-arrivals-img-contnent kitchen-card__media">
              <img
                className="img-fluid"
                src={
                  photo ? `${config.UPLOADS_SERVER}/category/${photo}` : videImg
                }
                alt={categoryDetails?.map((item) => item.categoryTitle)}
              />
            </div>

            <div className="new-arrival-content kitchen-card__title">
              <h4>
                <Link to="#">
                  {categoryDetails.map((item) =>
                    item.language === "en" ? item.categoryTitle : null
                  )}
                </Link>
              </h4>
              <div className="mt-3 px-1">
                <div className="text-center small text-muted mb-2 fw-semibold">
                  {t("displayOrientation")}
                </div>
                <div
                  className="subcategory-orient-switch"
                  role="group"
                  aria-label={t("displayOrientation")}
                >
                  <button
                    type="button"
                    className={`subcategory-orient-switch__option${
                      displayOrientation === "vertical" ? " is-active" : ""
                    }`}
                    aria-pressed={displayOrientation === "vertical"}
                    disabled={orientationSaving}
                    title={t("switchToVertical")}
                    onClick={() => setDisplayOrientationTo("vertical")}
                  >
                    <i className="fas fa-grip-vertical subcategory-orient-switch__icon" aria-hidden />
                    <span>{t("vertical")}</span>
                  </button>
                  <button
                    type="button"
                    className={`subcategory-orient-switch__option${
                      displayOrientation === "horizontal" ? " is-active" : ""
                    }`}
                    aria-pressed={displayOrientation === "horizontal"}
                    disabled={orientationSaving}
                    title={t("switchToHorizontal")}
                    onClick={() => setDisplayOrientationTo("horizontal")}
                  >
                    <i className="fas fa-grip-horizontal subcategory-orient-switch__icon" aria-hidden />
                    <span>{t("horizontal")}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
